import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-del-ico",
  "use": "icon-del-ico-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-del-ico\">\n  <defs>\n    <style type=\"text/css\"></style>\n  </defs>\n  <path d=\"M0 192h1024v128H0V192z m320-192h384v128H320V0z\" p-id=\"1799\" />\n  <path d=\"M128 256h128v768H128V256z m640 0h128v768h-128V256z\" p-id=\"1800\" />\n  <path d=\"M128 896h768v128H128v-128z m192-512h128v448H320V384z m256 0h128v448H576V384z\" p-id=\"1801\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol